import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";
import { getDefaultHeaders, getDefaultAuthConfig } from "../mainService";

export const getCanalList = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

    const serverResponse = await mainAxios.get(
      "/v1/canal/list",
      config
    );
    
    return serverResponse.data

};

export const getlDispocionesClienteList = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

    const serverResponse = await mainAxios.get(
      "/v1/disposiciones_cliente/list",
      config
    );
    
    return serverResponse.data.data.dispociones

};

export const postCrearDispocicion = async (form) => {
    const serverResponse = await mainAxios.post(
      "/v1/disposiciones_outbound",
      form,
      getDefaultHeaders()
    );

    return serverResponse.data

};

export const updateDispocicion = async (form) => {
  const serverResponse = await mainAxios.put(
    "/v1/disposiciones_outbound",
    form,
    getDefaultHeaders()
  );

  return serverResponse.data;
};



export const saveCargaMasiva = async (form) => {
  const serverResponse = await mainAxios.post(
    "/v1/disposiciones_outbound/masiva",
    form,
    {
      headers: {
        ...getDefaultAuthConfig(), // Authorization
      },
    }
  );
  return serverResponse;
};


export const filtrarDispociciones = async (form) => {
  const serverResponse = await mainAxios.post(
    "/v1/disposiciones_outbound/filter",
    form,
    {
      headers: {
        ...getDefaultAuthConfig(), // Authorization
      },
    }
  );
  return serverResponse;
};

